module.exports = __webpack_public_path__ + "static/media/hk.406844d2.svg";